import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';
import './Header.css';

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const handleMenuClick = () => {
    setMenuOpen(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <header className="header">
      <div className="container nav-container">
        <Link to="/" className="logo">
          <img className="logo-icon" src="/images/Retina.png" alt="C.U Fredson logo" />
          <span className="logo-copy">
            <strong>C.U Fredson</strong>
            <small>Engineering solutions</small>
          </span>
        </Link>
        
        <button
          className="nav-toggle"
          onClick={toggleMenu}
          aria-label={menuOpen ? 'Close navigation menu' : 'Open navigation menu'}
          aria-expanded={menuOpen}
          aria-controls="primary-navigation"
        >
          {menuOpen ? <FaTimes /> : <FaBars />}
        </button>

        <nav id="primary-navigation" className={`nav-menu ${menuOpen ? 'active' : ''}`}>
          <Link to="/" className="nav-link" onClick={handleMenuClick}>Home</Link>
          <Link to="/about" className="nav-link" onClick={handleMenuClick}>About</Link>
          <Link to="/services" className="nav-link" onClick={handleMenuClick}>Services</Link>
          <Link to="/projects" className="nav-link" onClick={handleMenuClick}>Projects</Link>
          <Link to="/gallery" className="nav-link" onClick={handleMenuClick}>Gallery</Link>
          <Link to="/contact" className="nav-link" onClick={handleMenuClick}>Contact</Link>
          <a href="https://wa.me/+2348034648000" className="cta-button" target="_blank" rel="noopener noreferrer">
            <span>Start a Project</span>
            <span className="cta-arrow" aria-hidden="true">&#8594;</span>
          </a>
        </nav>
      </div>
    </header>
  );
}

export default Header;
